export const orangeHighlight = '#F2A138';
export const white = '#FFFFFF';
export const redBrilla = '#db4945';
export const redBrillaSoft = '#f6d1d0';
export const normalGrey = '#595959';
export const lightGrey = '#a2a2a2';
export const superLightGrey = '#CACACA';
